module.exports = __webpack_public_path__ + "215c73c1a46e117c55f221c7731c9074.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/foundation-hat.jpg
 ** module id = 451
 ** module chunks = 0
 **/